import { AdminPermissions } from "../../Enum/AdminPermissionsType"

export const AdminEmployeeTypePresets: Record<string, string[]> = {
  analytics: [
    AdminPermissions.CanViewOverview,
    AdminPermissions.CanViewFinancialMetrics,
    AdminPermissions.CanViewCommercialPerformance,
    AdminPermissions.CanManageGrowthInvestments,
  ],
  marketing: [
    AdminPermissions.CanViewOverview,
    AdminPermissions.CanViewLandingLeads,
    AdminPermissions.CanManagePlatformNotices,
  ],
  support: [
    AdminPermissions.CanViewOverview,
    AdminPermissions.CanManageSubscriptions,
    AdminPermissions.CanManagePlatformWhatsApp,
    AdminPermissions.CanManageTutorials,
  ],
  commercial: [
    AdminPermissions.CanViewOverview,
    AdminPermissions.CanManageSubscriptions,
    AdminPermissions.CanManagePlans,
    AdminPermissions.CanManagePlanCoupons,
    AdminPermissions.CanQueryMercadoPago,
  ],
  infrastructure: [
    AdminPermissions.CanViewOverview,
    AdminPermissions.CanViewServerRuntime,
    AdminPermissions.CanManageServerLogs,
  ],
}
